import { render, staticRenderFns } from "./MonitorScoreExamUpdate.vue?vue&type=template&id=12361724&"
import script from "./MonitorScoreExamUpdate.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports